import React, { useState, useEffect, useContext, useRef } from "react";
import newLogo from "../images/newLogo.svg";
import Button from "../components/common/Button";
import SuccessModal from "../components/common/Modal";
import NewCbtModal from "../components/common/NewCbtModal";
import Palette from "../svg/Palette";
import Clock from "../svg/Clock";
import ThreeDots from "../svg/ThreeDots";

import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import ReactHtmlParser, {
  convertNodeToElement,
  processNodes,
} from "react-html-parser";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { Link, Element } from "react-scroll";

const OnGoingTest2 = () => {
  const authContext = useContext(AuthContext);
  const history = useHistory();

  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [score, setScore] = useState("");
  const [submitSuccessMsg, setSubmitSuccessMsg] = useState(false);
  const [clickedAns, setClickedAns] = useState(false);
  const [currQstNum, setCurrQstNum] = useState(1);
  const [currQst, setCurrQst] = useState(0);
  const [clickedOption, setClickedOption] = useState();
  const [clickedNumbers, setClickedNumbers] = useState([]);

  const studentInfo = JSON.parse(localStorage.getItem("studentInfo"));
  const admissionnumber = studentInfo[0].admissionnumber;
  const schoolDomain = localStorage.getItem("schoolDomain");

  // const LSAnsweredQsts = JSON.parse(localStorage.getItem('answeredQsts')); IsExamOngoing
  let storedAnsweredQsts;
  if (localStorage.getItem("answeredQsts") === null) {
    localStorage.setItem("answeredQsts", JSON.stringify([]));
  } else {
    storedAnsweredQsts = JSON.parse(localStorage.getItem("answeredQsts"));
  }
  const clickedCbtItem = JSON.parse(localStorage.getItem("clickedCbtItem"));
  const examQuestions = JSON.parse(localStorage.getItem("examQuestions"));
  const isExamOngoing = JSON.parse(
    localStorage.getItem("clickedCbtItem")
  ).IsExamOngoing;
  const getLSMins = localStorage.getItem("minutes");

  let [seconds, setSeconds] = useState(60);
  let [minutes, setMinutes] = useState(
    getLSMins ? getLSMins : clickedCbtItem.duration - 1
  );
  let [hours, setHours] = useState(0);
  let ongoingStoredAnsweredQsts = [];

  //set timer
  useEffect(() => {
    if (isExamOngoing || authContext.isExamOngoing) {
      examQuestions.map((question, index) => {
        return ongoingStoredAnsweredQsts.push({
          qstNum: index + 1,
          selectedOpt: question.choice,
        });
      });
      localStorage.setItem(
        "ongoingAnsweredQsts",
        JSON.stringify(ongoingStoredAnsweredQsts)
      );
      const ongoingExamDet = () => {
        const timeLeft = examQuestions[0].timeLeft;
        const mins = timeLeft.substring(3, 5);

        const hrs = timeLeft.substring(1, 2);

        setMinutes(mins);
        setHours(hrs);
      };
      ongoingExamDet();
    }
  }, []);

  //html parser
  function transform(node, index) {
    // all links must open in a new window
    if (node.type === "tag" && node.name === "a") {
      node.attribs.target = "_blank";

      return convertNodeToElement(node, index, transform);
    }

    if (node.type === "tag" && node.name === "button") {
      return (
        <Button key={index}>{processNodes(node.children, transform)}</Button>
      );
    }
  }

  const HtmlParserOptions = {
    decodeEntities: true,
    transform,
  };

  //run timer
  let id = useRef(null);
  const stopTimer = () => {
    window.clearInterval(id.current);
  };

  useEffect(() => {
    id.current = window.setInterval(() => {
      setSeconds((c) => c - 1);
    }, 1000);

    return stopTimer;
  }, []);

  //add zero to single digit time
  function addZero(n) {
    return (parseInt(n, 10) < 10 ? "0" : "") + n;
  }

  useEffect(() => {
    if (seconds < 2 && minutes < 1) {
      handleSubmitExam();
    }

    return () => {};
  }, [seconds, minutes]);

  if (seconds === 0) {
    setSeconds(59);
    setMinutes(minutes - 1);
  }

  useEffect(() => {
    localStorage.setItem("minutes", minutes);
    const timeTrackerQueryBody = {
      // SchoolUrl: 'demo.edves.net',
      SchoolUrl: schoolDomain,
      examidx: clickedCbtItem.idx,
      // examidx: dataContext.clickedCbtItem.idx,
      admissionnumber,
      timeLeft: minutes,
    };

    const updateTime = async () => {
      try {
        const { data } = await axios.post(
          "student/updatetimetracker",
          timeTrackerQueryBody
        );
      } catch (error) {
        console.log("time tracker querry error", error);
      }
    };
    updateTime();
  }, [minutes]);

  //submit exam
  const handleSubmitExam = async () => {
    stopTimer();
    setShowSubmitModal(false);

    const submitQueryBody = {
      // SchoolUrl: 'demo.edves.net',
      SchoolUrl: schoolDomain,
      // examidx: dataContext.clickedCbtItem.idx,
      examidx: clickedCbtItem.idx,
      admissionnumber,
    };
    try {
      const { data } = await axios.post("/student/submitexam", submitQueryBody);

      if (data.status) {
        localStorage.removeItem("minutes");
        localStorage.removeItem("answeredQsts");
        setSuccessModal(true);
        setTimeout(() => {
          setSuccessModal(false);
          data.data.Message.studentScore.length > 0
            ? setScore(data.data.Message.studentScore[0])
            : setScore("No score");
          history.push("answers-review");
        }, 1000);
      } else {
        alert("Unable to submit exam, please try again");
      }
    } catch (error) {
      console.log("Submit Exam Error", error);
      alert("Encountered an error while submitting exam, please try again.");
      setSubmitSuccessMsg(true);
    }
  };

  //modal
  const onSubmit = () => {
    setShowSubmitModal(true);
  };

  const submitModalBtnAttr = {
    text: "Continue Exam",
    onClick: () => setShowSubmitModal(false),
  };
  const SubmitModalTitle = () => <>Submit Exam</>;

  const ExitModalTitle = () => <>Exit Exam</>;
  const whiteBtnAttr = {
    text: "Submit Exam",
    onClick: handleSubmitExam,
  };

  const SubmitModalBody = () => (
    <div className="mt-4 mb-1 text-gray-200 text-lg">
      Are you sure you want to submit this examination?
    </div>
  );

  const ExitModalBody = () => (
    <div className="mt-4 mb-1 text-gray-200 text-lg">
      Are you sure you want to exit this examination?
    </div>
  );
  const showModalStyling = classNames({
    "border-0 rounded-lg shadow-lg w-4/5 sm:w-2/5 p-6 relative flex flex-col mx-auto bg-white outline-none focus:outline-none": true,
  });

  const submitSuccessModalBody = () => (
    <div className="text-sm text-green-100 my-12 flex justify-center">
      Submitted Successfully!
    </div>
  );

  const scoreModalBody = () => (
    <div className="text-sm text-gray-800 my-12 flex justify-center">
      {score}
    </div>
  );

  const submitSuccessModalTitle = () => (
    <div className="text-base text-gray-100">Test Status</div>
  );

  const scoreModalTitle = () => (
    <div className="text-base text-gray-100">Your Score!</div>
  );

  const submitModalStyling = classNames({
    "border-0 rounded-lg shadow-lg w-64 p-8 relative mx-auto bg-white outline-none focus:outline-none": true,
  });

  const handleFinish = () => {
    setShowSubmitModal(true);
  };

  const handleCloseScoreModal = () => {
    setScore("");
    history.push("cbt");
  };

  const handleExitModal = () => {
    setScore("");
    history.push("cbt");
  };

  //handle option click
  const handleClicked = (option, questionNumber) => {
    setClickedNumbers((clickedNumbers) => [...clickedNumbers, questionNumber]);

    const configAnswrdQst = {
      qstNum: questionNumber,
      selectedOpt: option,
    };

    if (isExamOngoing || authContext.isExamOngoing) {
      const answrsMap = JSON.parse(localStorage.getItem("ongoingAnsweredQsts"));
      const newAnswered = answrsMap.map((item) =>
        item.qstNum === questionNumber ? { ...item, selectedOpt: option } : item
      );
      localStorage.setItem("ongoingAnsweredQsts", JSON.stringify(newAnswered));
    } else {
      if (storedAnsweredQsts.find((num) => num.qstNum === questionNumber)) {
        const newAnswered = storedAnsweredQsts.map((item) =>
          item.qstNum === questionNumber
            ? { ...item, selectedOpt: option }
            : item
        );
        localStorage.setItem("answeredQsts", JSON.stringify(newAnswered));
      } else {
        const newAnswered = [...storedAnsweredQsts, configAnswrdQst];
        localStorage.setItem("answeredQsts", JSON.stringify(newAnswered));
      }
    }

    const submitAnsQueryBody = {
      SchoolUrl: schoolDomain,
      examidx: clickedCbtItem.idx,
      admissionnumber,
      questionOptionId: option,
      questionidx: examQuestions[currQst].questionidx,
    };
    const submitAnswer = async () => {
      try {
        const { data } = await axios.post(
          `student/updateexam`,
          submitAnsQueryBody
        );
        console.log(data.data);
      } catch (error) {
        console.log("submit question error", error);
      }
    };
    submitAnswer();
    setClickedOption(option);
    setClickedAns(!clickedAns);
  };

  return (
    <>
      {showSubmitModal && (
        <NewCbtModal
          closeModal={() => setShowSubmitModal(false)}
          modalStyling={showModalStyling}
          Title={SubmitModalTitle}
          Body={SubmitModalBody}
          whiteBtnAttr={whiteBtnAttr}
          BtnAttr={submitModalBtnAttr}
          actionButtonText="Yes, submit and review answers"
          confirmAction={handleSubmitExam}
        />
      )}

      {showExitModal && (
        <NewCbtModal
          closeModal={() => setShowExitModal(false)}
          modalStyling={showModalStyling}
          Title={ExitModalTitle}
          Body={ExitModalBody}
          whiteBtnAttr={whiteBtnAttr}
          BtnAttr={submitModalBtnAttr}
          actionButtonText="Yes"
          confirmAction={handleExitModal}
        />
      )}
      {successModal && (
        <SuccessModal
          closeModal={() => setSuccessModal(false)}
          Body={submitSuccessModalBody}
          Title={submitSuccessModalTitle}
          modalStyling={submitModalStyling}
        />
      )}
      {score !== "" && (
        <SuccessModal
          closeModal={handleCloseScoreModal}
          Body={scoreModalBody}
          Title={scoreModalTitle}
          modalStyling={submitModalStyling}
        />
      )}
      <div className=" bg-white h-full">
        <nav className="flex justify-between items-center py-8 px-20 cbt-nav">
          <img src={newLogo} alt="edves-logo" />
          <p
            className="hidden sm:block ml-16  font-bold text-xl leading-5"
            style={{ color: "#141921" }}
          >
            {" "}
            Edves Academy Student Portal{" "}
          </p>
          <div className="flex items-center gap-10">
            <button
              className="px-6 py-2 rounded-sm flex gap-2 items-center"
              style={{ background: "#4D4DFF", color: "#fff" }}
              onClick={() => setShowExitModal(true)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.33464 14.6668C3.15782 14.6668 2.98826 14.5966 2.86323 14.4716C2.73821 14.3465 2.66797 14.177 2.66797 14.0002V2.00016C2.66797 1.82335 2.73821 1.65378 2.86323 1.52876C2.98826 1.40373 3.15782 1.3335 3.33464 1.3335H12.668C12.8448 1.3335 13.0143 1.40373 13.1394 1.52876C13.2644 1.65378 13.3346 1.82335 13.3346 2.00016V4.00016H12.0013V2.66683H4.0013V13.3335H12.0013V12.0002H13.3346V14.0002C13.3346 14.177 13.2644 14.3465 13.1394 14.4716C13.0143 14.5966 12.8448 14.6668 12.668 14.6668H3.33464ZM12.0013 10.6668V8.66683H7.33464V7.3335H12.0013V5.3335L15.3346 8.00016L12.0013 10.6668Z"
                  fill="white"
                />
              </svg>
              Exit Exam
            </button>
            <div style={{ cursor: "pointer" }} className="three-dots">
              <ThreeDots />
            </div>
          </div>
        </nav>
        <main className="bg-white body-wrapper ">
          <div className="exams-body-left">
            <h1>{clickedCbtItem.subjectname}</h1>
            <p>Questions 1 - {examQuestions.length}</p>
            <div className="questions-container">
              {examQuestions.map((el, i) => (
                <Element className="question-wrapper" key={i} name={i + 1}>
                  <div className="question">
                    <div className="question-number">
                      {" "}
                      <p className="question-number-i">{i + 1} </p>
                    </div>
                    <div className="question-text">
                      {ReactHtmlParser(
                        examQuestions[i]?.question,
                        HtmlParserOptions
                      )}
                    </div>
                  </div>
                  <div className="options-list">
                    <div
                      className="question-number"
                      style={{ visibility: "hidden" }}
                    >
                      <p className="question-number-i">{i + 1} </p>
                    </div>
                    <div className="options-wrapper">
                      {examQuestions[i]?.cbtExamsQuestionsOption.map((el) => (
                        <>
                          <div key={el.id}>
                            <p>{el.optionLabel.toUpperCase()} </p>
                            <div className="options-list-wrap">
                              <label>
                                <input
                                  className="radio-input"
                                  type="radio"
                                  name={el.questionidx}
                                  value=""
                                  onChange={() => {
                                    handleClicked(el.id, i + 1);
                                    setCurrQstNum(i + 1);
                                  }}
                                />
                                {ReactHtmlParser(el.option, HtmlParserOptions)}
                              </label>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </Element>
              ))}
            </div>
          </div>
          <div className="exams-body-right">
            <div className="exams-body-right-title">
              <Palette />
              <p>Question Palette</p>
            </div>
            <div className="exams-body-right-number-list">
              {Array(examQuestions.length)
                .fill(examQuestions.length)
                .map((_, index) => (
                  <Link
                    to={index + 1}
                    className={
                      clickedNumbers.includes(index + 1)
                        ? "answered-number"
                        : "number"
                    }
                    key={index}
                  >
                    <p> {index + 1} </p>
                  </Link>
                ))}
            </div>
            <div className="number-label-wrapper">
              <div className="number-label">
                <div className="answered"></div>
                <p>Answered</p>
              </div>

              <div className="number-label">
                <div className="unanswered"></div>
                <p>Unanswered</p>
              </div>
            </div>

            <div className="timer-section">
              <div className="timer-section-heading">
                <Clock />
                <p>Duration</p>
              </div>
              <div className="timer">
                <div className="timer-top">
                  <div className="timer-top-content">
                    <p>Hours</p>
                    <p>Minutes</p>
                    <p>Seconds</p>
                  </div>
                </div>
                <div className="timer-bottom-content">
                  <p>{addZero(hours)}</p>
                  <p>:</p>
                  <p>
                    {minutes.toString().length < 2 ? `0${minutes}` : minutes}
                  </p>
                  <p>:</p>
                  <p>{addZero(seconds)}</p>
                </div>
              </div>
            </div>

            <div className="cta-buttons-wrapper">
              <button className="submit-primary" onClick={onSubmit}>
                <svg
                  width="18"
                  height="13"
                  viewBox="0 0 18 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00072 10.172L16.1927 0.979004L17.6077 2.393L7.00072 13L0.636719 6.636L2.05072 5.222L7.00072 10.172Z"
                    fill="white"
                  />
                </svg>
                Submit
              </button>
              <button className="view-solution">View Solution</button>
            </div>
          </div>
        </main>
        <div className="mobile-bottom-bar">
          <div className="mobile-bottom-bar-inner">
            <div className="timer-section">
              <div className="timer-section-heading">
                <Clock />
                <p>Duration</p>
              </div>
              <div className="timer">
                <div className="timer-top">
                  <div className="timer-top-content">
                    <p>Hours</p>
                    <p>Minutes</p>
                    <p>Seconds</p>
                  </div>
                </div>
                <div className="timer-bottom-content">
                  <p>{addZero(hours)}</p>
                  <p>:</p>
                  <p>
                    {minutes.toString().length < 2 ? `0${minutes}` : minutes}
                  </p>
                  <p>:</p>
                  <p>{addZero(seconds)}</p>
                </div>
              </div>

              <div className="cta-buttons-wrapper">
                <button className="submit-primary" onClick={onSubmit}>
                  <svg
                    width="18"
                    height="13"
                    viewBox="0 0 18 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.00072 10.172L16.1927 0.979004L17.6077 2.393L7.00072 13L0.636719 6.636L2.05072 5.222L7.00072 10.172Z"
                      fill="white"
                    />
                  </svg>
                  Submit
                </button>
                <button className="view-solution">View Solution</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnGoingTest2;
